import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-unittype',
  templateUrl: './unittype.component.html',
  styleUrls: ['./unittype.component.scss']
})
export class UnittypeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
